module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('mu-appbar', {
    staticClass: "header",
    attrs: {
      "title": "发布帖子"
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "icon": "arrow_back"
    },
    on: {
      "click": _vm.goback
    },
    slot: "left"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('mu-tabs', {
    attrs: {
      "value": _vm.activeTab
    },
    on: {
      "change": _vm.handleTabChange
    }
  }, [_c('mu-tab', {
    attrs: {
      "value": "tab1",
      "title": "编辑"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "tab2",
      "title": "预览"
    }
  })], 1), _vm._v(" "), (_vm.activeTab === 'tab1') ? _c('div', {
    staticClass: "tab1"
  }, [_c('mu-text-field', {
    attrs: {
      "label": "请写标题",
      "fullWidth": "",
      "labelFloat": ""
    },
    model: {
      value: (_vm.editorTitle),
      callback: function($$v) {
        _vm.editorTitle = $$v
      },
      expression: "editorTitle"
    }
  }), _vm._v(" "), _c('mu-select-field', {
    staticClass: "choose",
    attrs: {
      "label": "请选择板块",
      "fullWidth": "",
      "errorText": _vm.errorText
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('mu-menu-item', {
    attrs: {
      "value": "ask",
      "title": "回答"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "value": "share",
      "title": "分享"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "value": "job",
      "title": "招聘"
    }
  })], 1), _vm._v(" "), _c('mu-text-field', {
    attrs: {
      "label": "正文",
      "hintText": "建议使用 Markdown 语法",
      "multiLine": "",
      "rows": 10,
      "rowsMax": 12,
      "fullWidth": true,
      "labelFocusClass": "label-focus",
      "underlineFocusClass": "underline-focus"
    },
    model: {
      value: (_vm.editorText),
      callback: function($$v) {
        _vm.editorText = $$v
      },
      expression: "editorText"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'tab2') ? _c('mu-flexbox-item', {
    domProps: {
      "innerHTML": _vm._s(_vm.markedText)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "publishBtn"
  }, [_c('mu-raised-button', {
    staticClass: "demo-raised-button",
    attrs: {
      "label": "发布",
      "primary": ""
    },
    on: {
      "click": _vm.publishText
    }
  })], 1)], 1), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": !_vm.accesstoken,
      "title": "温馨提示："
    }
  }, [_vm._v("\n    请先登录\n    "), _c('mu-flat-button', {
    attrs: {
      "primary": "",
      "to": "/vue-home/dist/",
      "label": "取消"
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "primary": "",
      "to": "/vue-home/dist/login",
      "label": "确定"
    },
    slot: "actions"
  })], 1), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.publish,
      "title": "温馨提示："
    }
  }, [_vm._v("\n    " + _vm._s(_vm.tipMsg) + "\n    "), _c('mu-flat-button', {
    attrs: {
      "label": "确定",
      "primary": ""
    },
    on: {
      "click": _vm.close
    },
    slot: "actions"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cffdbde"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/publish.vue
// module id = 140
// module chunks = 1